<script>

export default {
  props: {
    tableData: null,
  },
  components: {

  },
  data() {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortDesc: false,
      fields: [
        // {
        //   key: "id",
        //   sortable: true,
        // },
        {
          key: "fundSource",
          label: "Fund Source",
          sortable: true,
        },
        {
          key: "expiryDate",
          label: "Expiry Date",
          sortable: true,
        },
        {
          key: "account",
          label: "Account",
          tdClass: "align-middle",
        },
        {
          key: "budget",
          label: "Actual Cash",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "transactions",
          label: "Transactions",
        },
        {
          key: "actions",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
    };
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    processActualCash(data) {
      this.$emit("process-actual-cash", data);
    },

    formatCurrency(data) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "PHP",
      }).format(data);
    },
    formatDate(data) {
      return new Date(data).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    },
    checkExpiry(data) {
      return new Date() < new Date(data) ? true : false;
    },
    viewSchedule(data) {
      this.$emit("view-schedule", { id: data.id, sourceName: data.sourceName });
    },
    printAllotment(id) {
      this.$emit("printAllotment", id);
    },
    printUtilization(id) {
      this.$emit("printUtilization", id);
    },
    printObligations(id) {
      this.$emit("printObligations", id);
    },
    printDisbursement(id) {
      this.$emit("printDisbursement", id);
    },

    markAsFavorite(data, event) {
      if (data.isFavorite) {
        const oldClass = ["fas", "fa-heart", "text-warning"];
        const newClass = ["far", "fa-heart"];
        event.target.classList.remove(...oldClass);
        event.target.classList.add(...newClass);
        event.target.title = "Mark as Favorite";
        /** Remove favorites */
        this.$emit("remove-favorite", data);
      } else {
        const newClass = ["fas", "fa-heart", "text-warning"];
        const oldClass = ["far", "fa-heart"];
        event.target.classList.remove(...oldClass);
        event.target.classList.add(...newClass);
        event.target.title = "Remove as Favorite";
        /** Add favorites */
        this.$emit("add-favorite", data);
      }
    },

    showObligationModal(row) {
      this.$emit("showObligations", row);
    },
    showDisbursementModal(row) {
      this.$emit("showDisbursement", row);
    },
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
};
</script>

<template>
  <div>
    <div id="datatable_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_length" class="dataTables_length">
            <label class="d-inline-flex align-items-center">
              Show&nbsp;
              <b-form-select
                class="form-select form-select-sm mx-1"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
              >
              </b-form-select
              >&nbsp;entries
            </label>
          </div>
        </div>
        <!-- Search -->
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_filter" class="dataTables_filter text-md-end">
            <label class="d-inline-flex align-items-center">
              Search:
              <b-form-input
                v-model="filter"
                type="search"
                placeholder="Search..."
                class="form-control form-control-sm ms-2"
              ></b-form-input>
            </label>
          </div>
        </div>
        <!-- End search -->
      </div>
      <div class="row">
        <!-- table data -->
        <div class="col-lg-12">
          <div class="table-responsive mb-0">
            <b-table
              class="table project-list-table table-nowrap align-middle table-borderless"
              :items="tableData"
              :fields="fields"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
              show-empty
            >
              <template #empty="scope">
                <div class="text-center">
                  <h5 class="text-secondary">{{ scope.emptyText }}</h5>
                </div>
              </template>
              <template #table-busy>
                <div class="d-flex justify-content-center align-items-center">
                  <div class="preloader-component me-2">
                    <div class="status">
                      <div class="spinner-chase w-20px h-20px">
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                      </div>
                    </div>
                  </div>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template #cell(fundSource)="row">
                <h5 class="font-size-15 ps-0 pb-0 mb-1">
                  {{ row.item.sourceName }}
                  <span
                    v-if="!row.item.isFavorite"
                    class="far fa-heart font-size-11 align-top"
                    role="button"
                    @click="markAsFavorite(row.item, $event)"
                    title="Mark as Favorite"
                  ></span>
                  <span
                    v-else
                    class="fas fa-heart text-warning font-size-11 align-top"
                    role="button"
                    @click="markAsFavorite(row.item, $event)"
                    title="Remove as Favorite"
                  ></span>
                </h5>
                <span class="text-muted ps-0 font-size-11">{{
                  row.item.description
                }}</span>
              </template>
              <template #cell(account)="row">
                <p class="ps-0">
                  <span class="text-muted font-size-13"
                    >Bank: <strong>{{ row.item.bankName }}</strong></span
                  >
                  <br />
                  <span class="text-muted font-size-13"
                    >Account: <strong>{{ row.item.accountNumber }}</strong></span
                  >
                </p>
              </template>
              <template #cell(budget)="row">
                <span class="badge rounded-pill badge-soft-warning font-size-12">{{
                  formatCurrency(row.item.actualCashBalance)
                }}</span>
              </template>
              <template #cell(transactions)="row">
                <p class="mb-0">
                  <small>Total Obligations</small>
                </p>
                <span class="text-warning me-2"
                  >{{ row.item.obligationPercentage.toFixed(2) }}%</span
                >

                <span
                  class="badge rounded-pill badge-soft-info font-size-12 cursor-pointer"
                  @click="showObligationModal(row.item)"
                  >{{ formatCurrency(row.item.totalObligations) }}</span
                >
                <hr class="mb-0 mt-2" />
                <p class="mb-0">
                  <small>Total Disbursements</small>
                </p>
                <span class="text-warning me-2"
                  >{{ row.item.disbursementPercentage.toFixed(2) }}%</span
                >

                <span
                  class="badge rounded-pill badge-soft-info font-size-12 cursor-pointer"
                  @click="showDisbursementModal(row.item)"
                  >{{ formatCurrency(row.item.totalDisbursement) }}</span
                >
              </template>
              <template #cell(expiryDate)="row">
                <span
                  class="badge ms-1 align-bottom font-size-12"
                  :class="[checkExpiry(row.item.expiry) ? 'bg-success' : 'bg-danger']"
                  >{{ formatDate(row.item.expiry) }}</span
                >
              </template>
              <template #cell(actions)="row">
                <b-button variant="link" size="sm" :id="`popover-target-${row.item.id}`">
                  <i class="fas fa-ellipsis-h"></i>
                </b-button>
                <b-popover
                  :target="`popover-target-${row.item.id}`"
                  triggers="click blur"
                  placement="leftbottom"
                  variant="secondary"
                  custom-class="p-0 p-custom-class"
                >
                  <div class="accordion w-100" role="tablist">
                    <b-card no-body class="mb-0">
                      <b-card-header header-tag="header" class="p-0">
                        <b-list-group-item
                          button
                          action
                          tabindex="0"
                          v-b-toggle.accordion-1
                          class="list-group-item list-group-item-action text-dark text-left"
                        >
                          <i class="far fa-list-alt font-size-15 align-middle me-2"></i>
                          Transactions
                        </b-list-group-item>
                      </b-card-header>
                      <b-collapse
                        id="accordion-1"
                        accordion="my-accordion"
                        role="tabpanel"
                      >
                        <b-card-text>
                          <b-list-group class="w-100">
                            <b-list-group-item
                              button
                              action
                              @click="processActualCash(row.item)"
                              tabindex="0"
                            >
                              <i class="bx bx-transfer font-size-18 align-middle me-2"></i
                              >Actual Cash Transactions
                            </b-list-group-item>

                            <b-list-group-item
                              button
                              action
                              @click="showObligationModal(row.item)"
                            >
                              <i
                                class="mdi mdi-newspaper-variant-outline font-size-18 align-middle me-2"
                              ></i
                              >View Obligations
                            </b-list-group-item>

                            <b-list-group-item
                              button
                              action
                              @click="showDisbursementModal(row.item)"
                            >
                              <i
                                class="mdi mdi-newspaper-variant-outline font-size-18 align-middle me-2"
                              ></i
                              >View Disbursements
                            </b-list-group-item>
                          </b-list-group>
                        </b-card-text>
                      </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-0">
                      <b-card-header header-tag="header" class="p-0" role="tab">
                        <b-list-group-item
                          button
                          action
                          tabindex="0"
                          v-b-toggle.accordion-2
                          class="list-group-item list-group-item-action text-dark text-left"
                          ><i class="fas fa-tools font-size-15 align-middle me-2"></i>
                          Options</b-list-group-item
                        >
                      </b-card-header>
                      <b-collapse
                        id="accordion-2"
                        accordion="my-accordion"
                        role="tabpanel"
                      >
                        <b-card-text>
                          <b-list-group class="w-100">
                            <b-list-group-item action @click="viewSchedule(row.item)"
                              ><i
                                class="bx bx-calendar font-size-18 align-middle me-2"
                              ></i
                              >Utilization Schedule
                            </b-list-group-item>
                          </b-list-group>
                        </b-card-text>
                      </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-0">
                      <b-card-header header-tag="header" class="p-0" role="tab">
                        <b-list-group-item
                          button
                          action
                          tabindex="0"
                          v-b-toggle.accordion-3
                          class="list-group-item list-group-item-action text-dark text-left"
                          ><i class="far fa-file-alt font-size-15 align-middle me-2"></i>
                          Reports</b-list-group-item
                        >
                      </b-card-header>
                      <b-collapse
                        id="accordion-3"
                        accordion="my-accordion"
                        role="tabpanel"
                      >
                        <b-card-text>
                          <b-list-group class="w-100">
                            <b-list-group-item
                              action
                              @click="printAllotment(row.item.id)"
                            >
                              <i class="bx bx-receipt font-size-18 align-middle me-2"></i
                              >Expenditure Allotment
                            </b-list-group-item>
                            <b-list-group-item
                              action
                              @click="printUtilization(row.item.id)"
                              ><i class="bx bx-money font-size-18 align-middle me-2"></i
                              >Utilization Report
                            </b-list-group-item>
                            <b-list-group-item
                              action
                              @click="printObligations(row.item.id)"
                              ><i class="bx bx-poll font-size-18 align-middle me-2"></i
                              >Obligation Report
                            </b-list-group-item>
                            <b-list-group-item
                              action
                              @click="printDisbursement(row.item.id)"
                              ><i
                                class="mdi mdi-book-arrow-right-outline font-size-18 align-middle me-2"
                              ></i
                              >Disbursement Report
                            </b-list-group-item>
                          </b-list-group>
                        </b-card-text>
                      </b-collapse>
                    </b-card>
                  </div>
                </b-popover>
              </template>
            </b-table>
          </div>
        </div>
        <!-- table data -->
      </div>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.p-custom-class .popover-body {
  padding: 0 !important;
  border: 0 !important;
}

.p-custom-class .list-group-item {
  border: 0 !important;
}
</style>
